export { parsePhoneNumber } from './mobileNumberValidation';
